/* Fly-to-cart chip — ported from AuraVera (Horizon fly-to-cart.js).
   On add to cart, the product image shrinks to a chip and flies from the
   clicked button to the header cart icon. window.flyToCartPending resolves
   when the flight lands, so a redirect to /cart can wait for it. */
(function () {
  if (window.__flyToCartInit) return;
  window.__flyToCartInit = true;

  var nextFrame = function () {
    return new Promise(function (r) { requestAnimationFrame(function () { requestAnimationFrame(r); }); });
  };

  if (!customElements.get('fly-to-cart')) {
    customElements.define('fly-to-cart', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var io = new IntersectionObserver(function (entries) {
          var s = null, d = null;
          entries.forEach(function (en) {
            if (en.target === self.source) s = en.boundingClientRect;
            else if (en.target === self.destination) d = en.boundingClientRect;
          });
          io.disconnect();
          if (s && d) self.animate_(s, d); else self.finish_();
        });
        io.observe(this.source);
        io.observe(this.destination);
        this.fallback_ = setTimeout(function () { self.finish_(); }, 1200);
      }
      async animate_(s, d) {
        var sx = s.left + s.width / 2, sy = s.top + s.height / 2;
        var dx = d.left + d.width / 2, dy = Math.max(d.top + d.height / 2, 16);
        var swing = Math.min(215, window.innerWidth * 0.21) * (dx >= sx ? 1 : -1);
        this.style.setProperty('--swing', swing + 'px');
        this.style.setProperty('--start-x', sx + 'px');
        this.style.setProperty('--start-y', sy + 'px');
        this.style.setProperty('--travel-x', (dx - sx) + 'px');
        this.style.setProperty('--travel-y', (dy - sy) + 'px');
        await nextFrame();
        await Promise.allSettled(this.getAnimations().map(function (a) { return a.finished; }));
        this.finish_();
      }
      finish_() {
        clearTimeout(this.fallback_);
        if (this.done_) this.done_();
        this.remove();
      }
    });
  }

  var visible = function (el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  };

  var onScreen = function (el) {
    if (!visible(el)) return false;
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  };

  var findCartIcon = function () {
    var list = document.querySelectorAll('#cart-icon-bubble, header a[href$="/cart"]');
    for (var i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
    return null;
  };

  var imgSrc = function (img) { return img && (img.currentSrc || img.src); };

  var mainGallery = function (form) {
    var ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType || ogType.content !== 'product') return null;
    var scope = form.closest('.shopify-section') || form.closest('section');
    return scope && scope.querySelector('.product__media-item.is-active img, .product__media img, .product__media-list img, [id^="MediaGallery"] img');
  };

  var findImage = function (form, source) {
    var sticky = source.closest('eck-sticky-atc');
    if (sticky) {
      var t = sticky.querySelector('[data-eck-sticky-thumb] img, img');
      if (imgSrc(t)) return imgSrc(t);
    }
    var g = mainGallery(form);
    if (imgSrc(g)) return imgSrc(g);
    for (var p = form.parentElement, k = 0; p && p !== document.body && k < 8; p = p.parentElement, k++) {
      var im = p.querySelector('img');
      if (imgSrc(im)) return imgSrc(im);
    }
    var og = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');
    return og ? og.content : null;
  };

  var lastClick = null;
  document.addEventListener('click', function (e) {
    // Only real taps: a sticky bar that forwards to the main button with .click() should keep its own button as the source.
    if (!e.isTrusted) return;
    var b = e.target.closest && e.target.closest('button, [type="submit"]');
    if (b) lastClick = { el: b, t: Date.now() };
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (!form.closest('product-form') || form.closest('quick-add-modal')) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;

    var source = e.submitter || btn;
    if (lastClick && Date.now() - lastClick.t < 1000 && onScreen(lastClick.el)) source = lastClick.el;
    if (!onScreen(source)) return;

    var cartIcon = findCartIcon();
    var image = findImage(form, source);
    if (!cartIcon || !image) return;

    var el = document.createElement('fly-to-cart');
    var kind = source.closest('eck-sticky-atc') ? 'sticky' : mainGallery(form) ? 'main' : 'quick';
    el.classList.add('fly-to-cart--' + kind);
    el.style.setProperty('background-image', 'url("' + image + '")');
    el.style.setProperty('--start-opacity', '0');
    el.source = source;
    el.destination = cartIcon;
    window.flyToCartPending = new Promise(function (r) { el.done_ = r; });
    document.body.appendChild(el);
  }, true);
})();